import { render, staticRenderFns } from "./InfoTextSetting.vue?vue&type=template&id=8515c208&"
import script from "./InfoTextSetting.vue?vue&type=script&lang=js&"
export * from "./InfoTextSetting.vue?vue&type=script&lang=js&"
import style0 from "../../../../public/authservice/etc/userfront/src/css/index.css?vue&type=style&index=0&lang=css&"
import style1 from "../../../../public/authservice/etc/userfront/src/css/authList.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VRow,VTextarea})
